@if (displayOnboardingStatus && displayOnboardingStatus.status) {
  <div class="onboarding-status {{displayOnboardingStatus?.styleClass}}">
    <span>{{displayOnboardingStatus?.label | l10n}}</span>
  </div>
}
